import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'
import { DiscoveredTerminalItem, TerminalStatus } from '../discovered-list/discovered-list.service'

/** 已忽略终端项（与已发现终端结构相同） */
export type IgnoredTerminalItem = DiscoveredTerminalItem

/** 已忽略终端列表请求 */
export interface IgnoredTerminalListReq {
  keyword?: string
  /** 每页数量 */
  limit?: number
  /** 页码 */
  page?: number
  /** 终端状态 */
  status?: TerminalStatus
  /** 系统类型,0-全部，1-windows,2-linux，3-windows server，4-mac */
  system_type?: number
}

/** 已忽略终端列表响应 */
export interface IgnoredTerminalListRes {
  list?: IgnoredTerminalItem[]
  total?: number
}

@Injectable()
export class IgnoredListService {
  constructor (private http: Http) {
  }

  /** 获取已忽略终端列表 */
  @ParamsClean()
  @InvokeThrottle()
  getIgnoredTerminalList (data: IgnoredTerminalListReq) {
    data.system_type ||= undefined
    return this.http.post<IgnoredTerminalListRes>('/client_find/discovered_list', {
      ...data,
      status: TerminalStatus.ignored
    })
  }

  /** 添加/更新终端备注 */
  @InvokeThrottle()
  updateTerminalRemark (data: { id: string, remarks?: string }) {
    return this.http.post<void>('/client_find/remark_update', data)
  }

  /** 导出已忽略终端 */
  download (type: 0 | 1, options: IgnoredTerminalListReq, moduleName: string) {
    const params = {
      ...options,
      status: TerminalStatus.ignored,
      file_type:type,
      limit: 0,
      page: 0
    }
    params.system_type ||= undefined
    return this.http.downloadWithBlob('/client_find/discovered_list_export', params, moduleName)
  }
}

